// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__uTQDG","list":"Navbar_list__laIOF","item":"Navbar_item__6fjWN","logo":"Navbar_logo__2e8Iv"};